import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { AssignField } from '@/components/modules/form/AssignField';
import { SmallTagOutline } from '@/components/ui/Tag/SmallTagOutline';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
import { draftCheck, validateOfferAssign, } from '@/utils/validate/resources/rfp/professional/rfpProOffer';
/**
 * コンサル案件提案 利用規約確認
 */
export const RfpProOfferFormSectionAssign = (props) => {
    const { className = '', fieldNameOfAssign, tagName: Tag = 'section' } = props;
    return (_jsxs(Tag, Object.assign({ className: clsx(FIELD_DOM_CLASS_NAME, className) }, { children: [_jsxs(Head, Object.assign({ className: clsx('mb-16', 'flex items-center'), size: 'sm' }, { children: [_jsx("span", { children: "\u898F\u7D04\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044" }), _jsx(SmallTagOutline, Object.assign({ className: 'flex-shrink-0 ml-8', color: 'secondary', isKanjiTopFixed: true }, { children: "\u5FC5\u9808" }))] })), _jsx(AssignField, { name: fieldNameOfAssign, validate: draftCheck(validateOfferAssign) })] })));
};
